import { BaseCanvasPack } from "./BaseCanvasPack";

export default class DeepSeaCanvasPack extends BaseCanvasPack {
  drawBackground(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number,
    level?: number
  ): void {
    const gradient = context.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, "#003347");
    gradient.addColorStop(0.6, "#001a24");
    gradient.addColorStop(1, "#00060d");
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);
  }

  drawFrame(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {

    // Border (rusted metal / pressure gauge look)
    const borderWidth = 4;
    context.strokeStyle = "#455A64"; // Blue grey
    context.lineWidth = borderWidth;
    context.strokeRect(borderWidth/2, borderWidth/2, width - borderWidth, height - borderWidth);
    
    // Rivets
    context.fillStyle = "#37474F";
    for (let i = 10; i < width; i += 30) {
      context.beginPath();
      context.arc(i, borderWidth/2, 2, 0, Math.PI*2);
      context.arc(i, height - borderWidth/2, 2, 0, Math.PI*2);
      context.fill();
    }
    for (let i = 10; i < height; i += 30) {
      context.beginPath();
      context.arc(borderWidth/2, i, 2, 0, Math.PI*2);
      context.arc(width - borderWidth/2, i, 2, 0, Math.PI*2);
      context.fill();
    }
  }

  drawOverlay(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {
    if (frameTime !== undefined) {
      this.drawBubbles(context, width, height, frameTime);
      this.drawFish(context, width, height, frameTime);
    }
  }

  private drawBubbles(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    context.fillStyle = "rgba(255, 255, 255, 0.3)";
    context.strokeStyle = "rgba(255, 255, 255, 0.5)";
    context.lineWidth = 1;
    
    const count = 20;
    for (let i = 0; i < count; i++) {
      const seed = i * 12.34;
      const speed = 0.03 + (i % 3) * 0.01;
      const x = (Math.sin(seed) * width + Math.sin(frameTime * 0.001 + seed) * 20 + width) % width;
      const y = (height - (frameTime * speed + seed * 100) % (height + 50));
      const size = 2 + (i % 4);
      
      context.beginPath();
      context.arc(x, y, size, 0, Math.PI * 2);
      context.fill();
      context.stroke();
      
      // Highlight
      context.beginPath();
      context.arc(x - size * 0.3, y - size * 0.3, size * 0.2, 0, Math.PI * 2);
      context.fillStyle = "rgba(255, 255, 255, 0.6)";
      context.fill();
      context.fillStyle = "rgba(255, 255, 255, 0.3)"; // Reset
    }
    context.restore();
  }

  private drawFish(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    
    // Occasional fish swimming by
    const fishTime = frameTime % 10000;
    if (fishTime < 2000) {
      const progress = fishTime / 2000;
      const x = width + 50 - progress * (width + 100); // Right to left
      const y = height * 0.7 + Math.sin(progress * 10) * 20;
      
      context.fillStyle = "#00BCD4"; // Cyan fish
      context.beginPath();
      // Simple fish shape
      context.ellipse(x, y, 15, 8, 0, 0, Math.PI * 2);
      context.fill();
      
      // Tail
      context.beginPath();
      context.moveTo(x + 15, y);
      context.lineTo(x + 25, y - 8);
      context.lineTo(x + 25, y + 8);
      context.fill();
    }
    
    context.restore();
  }

  getBorderStyle(): string {
    return "4px solid #455A64";
  }

  getBoxShadow(frameTime?: number): string {
    return "0 0 20px rgba(0, 96, 100, 0.6)";
  }

  getBackdropFilter(): string {
    return "blur(3px)";
  }
}

